export default __webpack_public_path__ + "static/media/0_Intro.aaada269.mp4";